import { CaptureResult } from '@qkindex/contracts';
import { RapidCaptureRecord } from '../features/rapidCapture/rapidCaptureTypes';
import { imageOperationService } from './imageOperationService';

export type CaptureStatus = CaptureResult;
const identity = (record: RapidCaptureRecord) => ({
  collectionId: record.collectionId,
  operationId: record.operationId,
  expectedMembershipVersion: record.membershipVersion,
});
export const captureService = {
  submit(record: RapidCaptureRecord): Promise<CaptureStatus> {
    return imageOperationService.submit(
      {
        action: 'capture-submit',
        ...identity(record),
        itemId: record.itemId,
        fields: {
          keywords: record.keywords,
          location: record.location,
          qty: record.qty,
          ...(record.locationId ? { locationId: record.locationId } : {}),
          ...(record.tagIds === undefined ? {} : { tagIds: record.tagIds }),
        },
        ...(record.analyzeImage
          ? {
              analysisOperationId: record.analysisOperationId,
              acceptedAiCostVersion: record.acceptedAiCostVersion,
            }
          : {}),
      },
      record.image,
    );
  },
  control(
    record: RapidCaptureRecord,
    phase: 'status' | 'retry' | 'save' | 'discard',
  ): Promise<CaptureStatus> {
    return imageOperationService.submit({
      action: 'capture-control',
      ...identity(record),
      phase,
      ...(phase === 'retry' && record.analyzeImage
        ? {
            analysisOperationId: record.analysisOperationId,
            acceptedAiCostVersion: record.acceptedAiCostVersion,
          }
        : {}),
    });
  },
};
